import React, { Component } from 'react';
import { Translation } from 'react-i18next';

function Ans1() {
  return (
    <Translation>
      {(t) => (
        <div className="bg" style={{ borderRadius: '0px 10px 10px 10px' }}>
          <ol className="ans">
            <li>
              <b className="fisrt-line">{t('ans_1.text_1')}</b>
              <p>{t('ans_1.text_2')}</p>
            </li>
            <li>
              <b>{t('ans_1.text_3')}</b>
              <p>{t('ans_1.text_4')}</p>
            </li>
            <li>
              <b>{t('ans_1.text_5')}</b>
              <b>{t('ans_1.text_6')}</b>
              <p>{t('ans_1.text_7')}</p>
              <ul>
                <li>{t('ans_1.text_8')}</li>
                <li>{t('ans_1.text_9')}</li>
                <li>{t('ans_1.text_10')}</li>
                <li>{t('ans_1.text_11')}</li>
                <li>{t('ans_1.text_12')}</li>
                <li>{t('ans_1.text_13')}</li>
                <li>{t('ans_1.text_14')}</li>
              </ul>
              <b>{t('ans_1.text_15')}</b>
              <p>{t('ans_1.text_16')}</p>
              <ul>
                <li>{t('ans_1.text_17')}</li>
                <li>{t('ans_1.text_18')}</li>
                <li>{t('ans_1.text_19')}</li>
                <li>{t('ans_1.text_20')}</li>
                <li>{t('ans_1.text_21')}</li>
              </ul>
            </li>
            <li>
              <b className="fisrt-line">{t('ans_1.text_22')}</b>
              <p>{t('ans_1.text_23')}</p>
              <p>{t('ans_1.text_24')}</p>
              <p>{t('ans_1.text_25')}</p>
              <p>{t('ans_1.text_26')}</p>
              <ul>
                <li>{t('ans_1.text_27')}</li>
                <li>{t('ans_1.text_28')}</li>
              </ul>
            </li>
          </ol>
        </div>
      )}
    </Translation>
  );
}

export default Ans1;
